import React from 'react';
import { useIntl } from 'react-intl';
import CategoryCard, { Category } from './components/CategoryCard';
import RedirectionModal from './../../common/components/modal/RedirectionModal';
import { useRedirectionModal } from './../../common/components/modal/hooks/useRedirectionModal';

const Telephonie = (): JSX.Element => {
  const intl = useIntl();
  const { isOpen, closeModal, confirmRedirection, handleContinue, pendingUrl } = useRedirectionModal();

  const categories: Category[] = [
    {
      id: 1,
      icon: 'fa-solid fa-people-group',
      title: 'Trunk Teams connect',
      description: intl.formatMessage({id: 'MARKETPLACE.TELEPHONY.TEAMS.TITLE'}),
      iconBg: 'primary',
      urlCommande: 'https://commande.celeste.fr/v8',
      urlEnSavoirPlus: 'https://www.celeste.fr/telephonie-fixe-et-mobile/telephonie-teams/',
      isActive: true,
    },
    {
      id: 2,
      icon: 'fa-solid fa-phone-volume',
      title: 'Trunk SIP',
      description: intl.formatMessage({id: 'MARKETPLACE.TELEPHONY.TRUNK_SIP.TITLE'}),
      iconBg: 'primary',
      urlCommande: 'https://commande.celeste.fr/v8',
      urlEnSavoirPlus: 'https://www.celeste.fr/telephonie-fixe-et-mobile/trunk-sip/',
      isActive: true,
    },
    {
      id: 3,
      icon: 'fa-solid fa-phone',
      title: intl.formatMessage({id: 'MARKETPLACE.TELEPHONY.IP.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.TELEPHONY.IP.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://commande.celeste.fr/v8',
      urlEnSavoirPlus:
        'https://www.celeste.fr/telephonie-fixe-et-mobile/solution-telephonie-cloud-centrex/',
      isActive: true,
    },
    {
      id: 4,
      icon: 'fa-solid fa-mobile-screen-button',
      title: intl.formatMessage({id: 'MARKETPLACE.TELEPHONY.MOBILE.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.TELEPHONY.MOBILE.DESC'}),
      iconBg: 'primary',
      urlCommande:
        'https://boutique.celeste.fr/categorie-produit/telephonie_mobile/smartphones?e-celeste=1',
      urlEnSavoirPlus:
        'https://www.celeste.fr/telephonie-fixe-et-mobile/telephonie-mobile-entreprise/',
      isActive: true,
    },
    {
      id: 5,
      icon: 'fa-solid fa-sim-card',
      title: intl.formatMessage({id: 'MARKETPLACE.TELEPHONY.PLANS.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.TELEPHONY.PLANS.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://commande.celeste.fr/mobile/telephonie/forfaits?e-celeste=1',
      urlEnSavoirPlus: '',
      isActive: true,
    },
  ];


  const handleOrder = (categoryTitle: string) => {
    const category = categories.find(cat => cat.title === categoryTitle);
    if (category?.urlCommande) {
      confirmRedirection(category.urlCommande);
    }
  };

  const handleLearnMore = (categoryTitle: string) => {
    const category = categories.find(cat => cat.title === categoryTitle);
    if (category?.urlEnSavoirPlus) {
      confirmRedirection(category.urlEnSavoirPlus);
    }
  };

  return (
    <>
      <RedirectionModal
        show={isOpen}
        onCancel={closeModal}
        onContinue={handleContinue}
        url={pendingUrl || ''}
      />

      <div className="row g-4">
        {categories.map((category) => (
          <CategoryCard
            key={category.id}
            category={category}
            onOrder={handleOrder}
            onLearnMore={handleLearnMore}
          />
        ))}
      </div>
    </>
  );
};

export default Telephonie;
